import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';

export const emptyEducationEntry = () => ({
  titulo: '',
  institucion: '',
  anio: '',
});

export const emptyExperienceEntry = () => ({
  cargo: '',
  lugar: '',
  periodo: '',
});

export const normalizeReviewLists = (review) => {
  if (!review) {
    return {
      resumen: '',
      formacion: [],
      experiencia: [],
      publicada: false,
      publicada_en: null,
      actualizado_en: null,
      avatar_url: null,
      especialista_nombre: '',
    };
  }

  return {
    resumen: review.resumen || '',
    formacion: Array.isArray(review.formacion) ? review.formacion : [],
    experiencia: Array.isArray(review.experiencia) ? review.experiencia : [],
    publicada: Boolean(review.publicada),
    publicada_en: review.publicada_en || null,
    actualizado_en: review.actualizado_en || null,
    avatar_url: review.avatar_url || null,
    especialista_nombre: review.especialista_nombre || '',
  };
};

export const fetchProfessionalReview = (usuarioId, solicitanteId = null) => {
  if (!usuarioId) {
    return Promise.reject(new Error('Usuario no válido.'));
  }

  if (!isApiEnabled()) {
    return Promise.reject(new Error('La reseña profesional requiere conexión con el servidor.'));
  }

  const payload = { usuario_id: usuarioId };

  if (solicitanteId) {
    payload.solicitante_id = solicitanteId;
  } else {
    payload.solicitante_id = usuarioId;
  }

  return api
    .post('/especialista_resena_obtener.php', payload)
    .then((response) => getApiData(response, 'No se pudo cargar la reseña profesional.'))
    .then((data) => normalizeReviewLists(data))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveProfessionalReview = (usuarioId, payload) => {
  if (!usuarioId) {
    return Promise.reject(new Error('Usuario no válido.'));
  }

  if (!isApiEnabled()) {
    return Promise.reject(new Error('La reseña profesional requiere conexión con el servidor.'));
  }

  return api
    .post('/especialista_resena_guardar.php', {
      usuario_id: usuarioId,
      solicitante_id: usuarioId,
      ...payload,
    })
    .then((response) => getApiData(response, 'No se pudo guardar la reseña profesional.'))
    .then((data) => normalizeReviewLists(data))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPublishedPresencialReview = (cedula) => {
  if (!cedula) {
    return Promise.reject(new Error('Especialista no válido.'));
  }

  if (!isApiEnabled()) {
    return Promise.reject(new Error('La reseña profesional requiere conexión con el servidor.'));
  }

  return api
    .post('/especialista_resena_presencial.php', { cedula })
    .then((response) => getApiData(response, 'No se pudo cargar la reseña del especialista.'))
    .then((data) => normalizeReviewLists(data))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPublishedProfessionalReview = (especialistaId) => {
  if (!especialistaId) {
    return Promise.reject(new Error('Especialista no válido.'));
  }

  if (!isApiEnabled()) {
    return Promise.reject(new Error('La reseña profesional requiere conexión con el servidor.'));
  }

  return api
    .post('/especialista_resena_publica.php', { especialista_id: especialistaId })
    .then((response) => getApiData(response, 'No se pudo cargar la reseña del especialista.'))
    .then((data) => normalizeReviewLists(data))
    .catch((error) => {
      throw parseApiError(error);
    });
};
